import { usePage } from "@inertiajs/react";
import AuditHandoffIntro from "@/components/auth/AuditHandoffIntro";
import AuthDivider from "@/components/auth/AuthDivider";
import AuthShell from "@/components/auth/AuthShell";
import AuthTermsFooter from "@/components/auth/AuthTermsFooter";
import ClaimHandoffIntro from "@/components/auth/ClaimHandoffIntro";
import EmailSignInForm from "@/components/auth/EmailSignInForm";
import GoogleSignInButton from "@/components/auth/GoogleSignInButton";
import ValuePropositions from "@/components/auth/ValuePropositions";
import FlashMessage from "@/components/FlashMessage";
import type { Flash } from "@/types";

type SessionsNewProps = {
  authenticity_token: string;
  sample_auth_enabled: boolean;
  audit_url?: string | null;
  claim_hostname?: string | null;
};

type SharedProps = {
  flash?: Flash;
};

export default function New({ authenticity_token, sample_auth_enabled, audit_url, claim_hostname }: SessionsNewProps) {
  const { flash } = usePage<SharedProps>().props;
  const claimHandoff = Boolean(claim_hostname);
  const auditHandoff = Boolean(audit_url) && !claimHandoff;

  return (
    <AuthShell>
      <FlashMessage flash={flash} />

      {claimHandoff && claim_hostname ? (
        <ClaimHandoffIntro hostname={claim_hostname} />
      ) : auditHandoff && audit_url ? (
        <AuditHandoffIntro auditUrl={audit_url} />
      ) : (
        <div className="text-center">
          <h1 id="login-heading" className="mb-4 font-sans text-4xl font-bold text-gray-900">
            Welcome to ScoutUX
          </h1>
          <p className="mb-6 text-xl font-medium text-gray-600">
            AI-powered usability analysis for your SaaS application
          </p>
          <ValuePropositions />
        </div>
      )}

      <div className="space-y-6">
        <div className="space-y-4">
          <GoogleSignInButton authenticityToken={authenticity_token} />
          {sample_auth_enabled ? (
            <form action="/auth/sample" method="post">
              <input type="hidden" name="authenticity_token" value={authenticity_token} />
              <button className="btn w-full py-3" type="submit">
                Continue with Sample Account
              </button>
            </form>
          ) : null}
          <AuthDivider />
          <EmailSignInForm auditUrl={audit_url} />
        </div>

        <AuthTermsFooter />
      </div>
    </AuthShell>
  );
}
